import type { PaymentCurrency_Enum } from '@/utilities/__generated__/graphql';
import { budgetFormatter } from '@/utilities/budgetFormatter';
import { removeExtraSpaces } from '@/utilities/removeExtraSpaces';
import type { BigNumberish } from 'ethers';

export function seoDescriptionDeal({
  companyName,
  collectionName,
  currency,
  minBudget,
  maxBudget,
  royaltyPercentage,
  requestedNumberOfNfts,
  numberOfCollections,
}: {
  companyName: string;
  collectionName: string;
  currency: PaymentCurrency_Enum;
  minBudget?: BigNumberish | null;
  maxBudget?: BigNumberish | null;
  royaltyPercentage?: string;
  requestedNumberOfNfts: number;
  numberOfCollections: number;
}): string {
  let budgetPart = '';
  let royaltyPart = '';
  if (minBudget && maxBudget) {
    budgetPart = budgetFormatter(minBudget, maxBudget, currency);
  }

  if (royaltyPercentage) {
    royaltyPart = `${royaltyPercentage}%`;
  }

  let budgetRoyaltyString = '';

  if (budgetPart && royaltyPart) {
    budgetRoyaltyString = `${budgetPart.trim()} and ${royaltyPart}`;
  } else if (budgetPart) {
    budgetRoyaltyString = budgetPart;
  } else if (royaltyPart) {
    budgetRoyaltyString = royaltyPart;
  }

  let collectionString = '';
  if (numberOfCollections > 1) {
    const suffix = numberOfCollections === 2 ? 'collection' : 'collections';
    collectionString = `and ${numberOfCollections - 1} other ${suffix}`;
  }

  const descriptionParts = [
    companyName,
    `is looking to license ${requestedNumberOfNfts}`,
    `${requestedNumberOfNfts === 1 ? 'NFT' : 'NFTs'}`,
    `on @OverpassIP from ${collectionName}`,
    collectionString,
  ];

  if (budgetRoyaltyString) {
    descriptionParts.push(`for a budget of ${budgetRoyaltyString} per NFT`);
  }

  return removeExtraSpaces(descriptionParts.join(' ')) + '.';
}
